import React, { useState, useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { createNewTheme } from '../../functions/utils';

import SideMenu from '../../components/SideMenu';
import Home from './Home';
import Pedidos from './Pedidos';
import Cardapio from './Cardapio';
import Inventario from './Inventario';
import QRCodeScreen from './QRCode';
import Personalizar from './Personalizar';
import Configuracoes from './Configuracoes';
import Suporte from './Suporte';
import Clientes from './Clientes';
import Despesas from './Despesas';
import '../../components/Scrollbar.css';
import Fechamento from './Fechamento';
import Dashboard from './Dashboard';
import PedidosDelivery from './PedidosDelivery';
import PedidosRetirada from './PedidosRetirada';
import PedidosMesa from './PedidosMesa';
import HistoricoPedidos from './HistoricoPedidos';
import CardapioVenda from './CardapioVenda';
import Enderecos from './Enderecos';
import Carrinho from './Carrinho';
import Pagamentos from './Pagamentos';
import Finalizar from './Finalizar';
import Finalizado from './Finalizado';
import SelecionarEndereco from './SelecionarEndereco';
import axios from 'axios';
import notificationSound from '../../functions/notification-song-2.mp3';

function HomeRouter() {

  const state = useLocation().state;
  const navigate = useNavigate();

  const [colorPrimary, setColorPrimary] = useState(state ? state.colorPrimary : "217, 217, 217");
  const [colorSecondary, setColorSecondary] = useState(state ? state.colorSecondary : "217, 217, 217");
  const [colorTertiary, setColorTertiary] = useState(state ? state.colorTertiary : "217, 217, 217");
  const [value, setValue] = useState('');
  const [updateP, setUpdate] = useState('');
  const [verificaSessao, setVerificaVersao] = useState(false);
  const audioRef = React.useRef(null);

  const limparTimersPedidos = () => {
    if (window.verificaUltimoPedido) {
      clearInterval(window.verificaUltimoPedido);
      window.verificaUltimoPedido = null;
    }
    if (window.verificarPedidosImprimir) {
      clearInterval(window.verificarPedidosImprimir);
      window.verificarPedidosImprimir = null;
    }
  }

  useEffect(() => {

    const idBase = localStorage.getItem("Md")
    const urlBase = localStorage.getItem("UBs")
    const isLogged = localStorage.getItem("isLogged")
    if (!idBase || !urlBase || !isLogged || isLogged !== "true") {
      console.log("SESSÃO EXPIRADA")
      localStorage.getItem("iSpA") === "true" ? localStorage.setItem('DSlP', true) : console.log(":..")
      localStorage.removeItem('dsEst');
      localStorage.removeItem('emEst');
      localStorage.removeItem('endEst');
      localStorage.removeItem('fMsP');
      localStorage.removeItem('hREst');
      localStorage.removeItem('iEst');
      localStorage.removeItem('nmEst');
      localStorage.removeItem('txEst');
      localStorage.removeItem('tEst');
      localStorage.removeItem('tsEst');
      localStorage.removeItem('UBs');
      localStorage.removeItem('FTs');
      localStorage.removeItem('isLogged');
      localStorage.removeItem('isStore');
      limparTimersPedidos();
      alert("Sua sessão expirou. Por favor, realize o login novamente.");
      navigate("/estabelecimento", { replace: true, state: { page: "home" } });
      return
    }
    setVerificaVersao(true);

    setColorPrimary(localStorage.getItem("clPmr"))
    setColorSecondary(localStorage.getItem("clScr"))
    setColorTertiary(localStorage.getItem("clTcr"))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const update = (event, newValue) => {
    setUpdate(newValue);
  };

  const handleChange = (event, newValue, page) => {
    if (event === "stlj") {
      setUpdate(`STLJ___${newValue}`);
    } else if (event === "pg") {
      setUpdate(`STPG___${newValue}`);
    } else if (newValue === "updateNot") {
      if (localStorage.getItem("iSpA") === "true") {
        getNovosPedidos()
      }
      return
    } else {
      setUpdate(`UPDTCLP___${localStorage.getItem("clPmr").split(", ")}`);
      setColorPrimary(localStorage.getItem("clPmr"))
      setColorSecondary(localStorage.getItem("clScr"))
      setColorTertiary(localStorage.getItem("clTcr"))
    }
    setValue(newValue);
  };

  const getNovosPedidos = () => {

    // const horariosestabelecimento = localStorage.getItem('hREst');
    // const horariosArray = horariosestabelecimento.split(",");
    // const d = new Date();
    // let diasemana
    // if (d.getDay() === 0) {
    //   diasemana = horariosArray[6]
    // } else {
    //   diasemana = horariosArray[d.getDay() - 1]
    // }

    // let unix1, unix2
    // if (diasemana === "Fechado") {
    //   unix1 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), "00", "00") / 1000);
    //   unix2 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), "23", "59") / 1000);
    // } else {
    //   const horarios = diasemana.split(" às ");
    //   const horario1 = horarios[0].split(":");
    //   unix1 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), horario1[0], horario1[1]) / 1000);
    //   const horario2 = horarios[1].split(":");
    //   unix2 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), horario2[0], horario2[1]) / 1000);
    // }

    // if (unix2 <= unix1) {
    //   unix2 += 86400
    // }

    const agora = new Date();

    const dataOntem = new Date(agora);
    dataOntem.setDate(agora.getDate() - 1);
    dataOntem.setHours(0, 0, 0, 0);

    const dataHojeFinal = new Date(agora);
    dataHojeFinal.setHours(23, 59, 59, 999);

    const unix1 = Math.floor(dataOntem.getTime() / 1000);
    const unix2 = Math.floor(dataHojeFinal.getTime() / 1000);

    const urlBase = localStorage.getItem('UBs');

    const post_url = urlBase + "/novos-pedidos.php";
    const json = JSON.stringify({
      idestabelecimentos: 1,
      unix1: unix1,
      unix2: unix2
    });
    axios.post(post_url, json)
      .then(async resp => {
        const response = resp.data

        if (!response) {
          localStorage.removeItem('nTMs')
          localStorage.removeItem('nTDn')
          localStorage.removeItem('nTRn')
          return;
        }
        response.mesasNovos > 0 ? localStorage.setItem('nTMs', true) : localStorage.removeItem('nTMs')
        response.deliveryNovos > 0 ? localStorage.setItem('nTDn', true) : localStorage.removeItem('nTDn')
        response.retiradaNovos > 0 ? localStorage.setItem('nTRn', true) : localStorage.removeItem('nTRn')

        if (response.mesasNovos > 0 || response.deliveryNovos > 0 || response.retiradaNovos > 0) {
          localStorage.removeItem("sPdd")
          const nt = localStorage.getItem("nTUpdt") === "true";

          const mesasNovas = localStorage.getItem("msNv") ? localStorage.getItem("msNv") : 0;
          const deliveryNovos = localStorage.getItem("dlNv") ? localStorage.getItem("dlNv") : 0;
          const retiradaNovos = localStorage.getItem("rtNv") ? localStorage.getItem("rtNv") : 0;
          if (!nt || mesasNovas !== response.mesasNovos || deliveryNovos !== response.deliveryNovos || retiradaNovos !== response.retiradaNovos) {
            localStorage.setItem('msNv', response.mesasNovos);
            localStorage.setItem('dlNv', response.deliveryNovos);
            localStorage.setItem('rtNv', response.retiradaNovos);
          }
          // setUpdate(`ATLPDD___${new Date().getTime()}`)

          localStorage.setItem('nTUpdt', true)

        } else {
          localStorage.setItem('sPdd', true);
          localStorage.removeItem("msNv")
          localStorage.removeItem("dlNv")
          localStorage.removeItem("rtNv")
          localStorage.removeItem('nTUpdt')
        }
      })
      .catch(error => {
        console.log(error)
        console.log("ERRO CÓDIGO 12")
      });
  }

  const renderContent = () => {
    switch (value) {
      case 'home':
        return <Home audioRef={audioRef} onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'cardapio':
        return <Cardapio onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'pedidos':
        return <Pedidos onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'inventario':
        return <Inventario onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'qrcode':
        return <QRCodeScreen onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'personalizar':
        return <Personalizar onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'configuracoes':
        return <Configuracoes onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'suporte':
        return <Suporte onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'clientes':
        return <Clientes onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'despesas':
        return <Despesas onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'fechamento':
        return <Fechamento onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      // PDV
      case 'dashboard':
        return <Dashboard onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'entrega':
        return <PedidosDelivery onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'retirada':
        return <PedidosRetirada onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'mesa':
        return <PedidosMesa onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'historico':
        return <HistoricoPedidos onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'cardapio-venda':
        return <CardapioVenda onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'carrinho':
        return <Carrinho onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'pagamentos':
        return <Pagamentos onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'enderecos':
        return <Enderecos onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'selecionar-endereco':
        return <SelecionarEndereco onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'finalizar':
        return <Finalizar onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'finalizado':
        return <Finalizado onChange={handleChange} update={update} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      default:
        setValue("home")
        return <Home />;
    }
  };

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      {verificaSessao &&
        <>
          <SideMenu onChange={handleChange} update={updateP} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />

          {renderContent()}

          <audio ref={audioRef}>
            <source src={notificationSound} type="audio/mpeg" />
          </audio>
        </>
      }

    </ThemeProvider>
  );
}

export default HomeRouter;